import { render, staticRenderFns } from "./CertificadosListado.vue?vue&type=template&id=36adc006&scoped=true&"
import script from "./CertificadosListado.vue?vue&type=script&lang=js&"
export * from "./CertificadosListado.vue?vue&type=script&lang=js&"
import style0 from "./CertificadosListado.vue?vue&type=style&index=0&id=36adc006&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36adc006",
  null
  
)

export default component.exports